import axios from 'axios-observable';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { PageableQuery, TalosPayload, UUID } from '../app/basicModels';
import { Indicator, IndicatorPage } from './models';
import CONFIG from '../../settings';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ObservationsConfigV2 } from '../observationsConfigV2';

const indicatorUrl = `${CONFIG.apiUrl}:${CONFIG.demeterPort}/api/v1/indicators`;

const validateIndicatorExprUrl = `${CONFIG.apiUrl}:${CONFIG.demeterPort}/api/v1/indicator/verify`;

export const getIndicators = (_query: PageableQuery, companyId: UUID, showCanonicals: boolean): AxiosObservable<IndicatorPage> => {
  if (companyId) {
    return axios.get<IndicatorPage>(
      `${indicatorUrl}?page=${_query.pageable.page}&size=${_query.pageable.size}&company_id=${companyId}&show_canonicals=${showCanonicals}`
    );
  }
  return axios.get<IndicatorPage>(
    `${indicatorUrl}?page=${_query.pageable.page}&size=${_query.pageable.size}&show_canonicals=${showCanonicals}`
  );
};

export const getIndicator = (indicatorId: UUID): AxiosObservable<Indicator> => {
  return axios.get<Indicator>(`${indicatorUrl}/${indicatorId}`);
};

export const saveIndicator = (indicator: TalosPayload<Indicator>, isNew: boolean): AxiosObservable<Indicator> => {
  if (isNew) {
    return createIndicator(indicator);
  }
  return updateIndicator(indicator);
};

export const validateIndicatorSimpleExpression = (indicator: Indicator): any => {
  return axios.post<any>(`${validateIndicatorExprUrl}`, indicator).pipe(
    map(response => response && { ...response.data, status: 200 }),
    catchError(error => of(error && error.response && error.response.data))
  );
};

export const createIndicator = (indicator: TalosPayload<Indicator>): AxiosObservable<Indicator> => {
  return ObservationsConfigV2.createIndicator(indicator.payload);
};

export const updateIndicator = (indicator: TalosPayload<Indicator>): AxiosObservable<Indicator> => {
  return ObservationsConfigV2.updateIndicator(indicator.payload);
};

export const deleteIndicator = (indicator: TalosPayload<Indicator>): AxiosObservable<Indicator> => {
  const { id } = indicator.payload;
  if (!id) throw new Error('Indicator id is required');
  return ObservationsConfigV2.deleteIndicator(id);
};

export const getIndicatorsForCompany = (_query: any): AxiosObservable<IndicatorPage> => {
  return axios.get<IndicatorPage>(
    `${indicatorUrl}?page=${_query.page.pageable.page}&size=${_query.page.pageable.size}&company_id=${
      _query.companyId
    }&show_canonicals=${true}`
  );
};

export const cloneIndicator = (indicatorId: UUID, companyId: UUID): AxiosObservable<Indicator> => {
  return ObservationsConfigV2.cloneIndicatorToOrg(indicatorId, companyId);
};

export const cloneIndicatorToWorkspace = (indicatorId: UUID, workspaceId: UUID): AxiosObservable<Indicator> => {
  return ObservationsConfigV2.cloneIndicatorToWorkspace(indicatorId, workspaceId);
};
